import { Container } from 'pixi.js';
import { UndoAnimationLayout } from '../../../../../layouts/boosters/UndoAnimationLayout';
import { playLayoutAnimation } from '../../../../libs/layouts/layoutAnimations/playLayoutAnimation';

export class BoosterUndoAnimation extends Container {
  private readonly layout = new UndoAnimationLayout();

  constructor() {
    super();

    this.layout.root.props({
      parent: this,
    });
  }

  public async animate(perform: () => void): Promise<void> {
    await playLayoutAnimation(this.layout, 'Undo_Booster_Animation', false, (eventName) => {
      if (eventName !== 'performUndo') return;
      perform();
    });
    this.destroy({ children: true });
  }
}
